export default "__VITE_ASSET__BX2Za1w5__"